/* eslint-disable react/prop-types */
import { useEffect, useRef, useState } from "react";
// Material Dashboard 2 React components
import { Cancel } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Snackbar,
  useMediaQuery,
} from "@mui/material";
import theme from "assets/theme";
import { useMemo } from "react";
import Draggable from "react-draggable";
import FormatField from "../../../components/FormatField/formatField";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const defaultValue = {
  ma: "",
  ten: "",
  ghichu: "",
  nhom: 1,
};
const FormNhomCha = ({
  data,
  open,
  onClose,
  onSubmit,
  title,
  validationErrors,
}) => {
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  // state lỗi giá trị từ form
  const [errors, setErrors] = useState({});
  const [dataState, setDataState] = useState(defaultValue);
  const formRef = useRef(null);
  const [alert, setAlert] = useState({
    alert: false,
    message: null,
    type: null,
  });

  const fieldInfor = useMemo(() => {
    let result = [
      {
        name: "Tên nhóm",
        key: "ten",
        type: "text",
        required: true,
        maxLength: 255,
        xs: 12,
        md: 9,
        lg: 9,
      },
      {
        name: "Phân nhóm",
        key: "nhom",
        type: "number",
        required: true,
        maxLength: 255,
        xs: 12,
        md: 3,
        lg: 3,
      },
      {
        name: "Số thứ tự",
        key: "sothutu",
        type: "number",
        required: true,
        maxLength: 255,
        xs: 12,
        md: 3,
        lg: 3,
      },
      {
        name: "Ghi chú",
        key: "ghichu",
        type: "textArea",
        xs: 12,
        md: 9,
        lg: 9,
        maxLength: 255,
      },
    ];
    return result;
  }, []);

  useEffect(() => {
    if (data?.id) {
      setDataState(data);
    } else {
      setDataState(defaultValue);
    }
  }, [data]);

  useEffect(() => {
    if (open) {
      setErrors([]);
    }
  }, [open]);

  async function onSubmitForm(event) {
    event.preventDefault();
    const _data = { ...dataState };
    _data["rowIndex"] = data?.rowIndex;
    let newValidationErrors = validateOBJ(_data);
    let _tempValid = newValidationErrors;
    if (Object.values(_tempValid).some((error) => error)) {
      setErrors((prev) => ({
        ...prev,
        ...newValidationErrors,
      }));
      return;
    }
    onSubmit(_data);
    setErrors({});
  }

  const handelClear = () => {
    onClose();
    setErrors({});
  };

  useEffect(() => {
    setErrors(validationErrors);
  }, [validationErrors]);

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ alert: false, message: null, type: null });
  };

  const handleChangeDataState = (data) => {
    let { name, value } = data;
    setDataState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleErrorDataState = (error) => {
    let { name, value } = error;
    setErrors((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      {alert.alert && (
        <Snackbar
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={alert.alert}
          onClose={handleCloseAlert}
        >
          <Alert onClose={handleCloseAlert} severity={alert.type}>
            {alert.message}
          </Alert>
        </Snackbar>
      )}
      <Dialog
        fullScreen={fullScreen}
        open={open}
        PaperComponent={PaperComponent}
        PaperProps={{
          sx: {
            "@media (min-width: 768px)": {
              minWidth: "40rem",
            },
          },
        }}
        onClose={handelClear}
      >
        {/* Form */}
        <form
          ref={formRef}
          method="post"
          encType="multipart/form-data"
          style={{
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            height: "100%",
          }}
        >
          {/* Tiêu đề modal - tham số title */}
          <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#ffffff" }}>
            {title ? title : "Chỉnh sửa nhóm"}
            <IconButton
              aria-label="close"
              onClick={handelClear}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers sx={{ overflow: "auto", padding: "1rem" }}>
            <Box>
              {/* show lỗi từ khi không xác định được từ các field ở form */}
              {errors && errors.error ? (
                <Grid container sx={{ textAlign: "center", mb: 0 }}>
                  <Grid item xs={12}>
                    <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                      {errors.error}
                    </Alert>
                  </Grid>
                </Grid>
              ) : (
                ""
              )}
              {fieldInfor?.length > 0 && (
                <FormatField
                  listField={fieldInfor}
                  data={dataState}
                  onChange={handleChangeDataState}
                  onError={handleErrorDataState}
                  errorValues={errors}
                />
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handelClear}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <Button
              type="submit"
              variant="contained"
              startIcon={<SaveIcon />}
              size="small"
              onClick={onSubmitForm}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Lưu
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};
const validateRequired = (value) => {
  let result = !!value?.length;
  if (typeof value == "number") {
    result = true;
  }
  return result;
};

function validateOBJ(lks) {
  let result = {
    // ma: !validateRequired(lks.ma) ? "Mã nhóm không được trống" : "",
    ten: !validateRequired(lks.ten) ? "Tên nhóm không được trống" : "",
  };
  return result;
}
export default FormNhomCha;
